#import "../fragments/inbox-thread-fragment.graphql"

query GetLatestThreads(
    $status: ThreadStatus
    $assignees: [ID!]
    $after: String
    $before: String
    $first: Int
    $threadType: ThreadType
    $findThreadId: ID
    $botStatus: ThreadBotStatus
    $contactFilter: ContactFilter
    $search: String
) {
    latestThreads(
        status: $status
        assignees: $assignees
        after: $after
        before: $before
        first: $first
        threadType: $threadType
        findThreadId: $findThreadId
        botStatus: $botStatus
        contactFilter: $contactFilter
        search: $search
    ) {
        totalCount
        pageInfo {
            startCursor
            endCursor
            hasNextPage
        }
        edges {
            node {
                ...InboxThreadFragment
            }
        }
    }
}
